export default {
    HEADERS: {
        ERROR_CODE: "x-error-code",
        ERROR_ID: "x-error-id",
        PAYLOAD_ERROR: "x-error-payload",
        MY_DEPOSIT_AUTHORIZATION: "x-mydeposit-authorization",
        AUTHORIZATION: "Authorization",
    },
    BEARER: "Bearer",
    STATUS_CODES: {
        UNAUTHORIZED: 401,
        FORBIDDEN: 403,
        NOT_FOUND: 404,
        BAD_REQUEST: 400,
        ENTITY_TOO_LARGE: 413,
    },
    ERROR_IDS: {
        MY_DEPOSIT_ACCESS_TOKEN_INVALID: "14",
    },
};
